import AuthService from "../../services/auth.service";

import { Link, useLocation } from "react-router-dom";
import ArrowIcon from "../../assets/images/arrow-right-up.svg";

import { Calendar as MonthCalendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { useState, useEffect } from "react";

import moment from "moment";

import EarnedLeave from "../../assets/images/earnedLeave.svg";
import LOP from "../../assets/images/lop.svg";
import CompOff from "../../assets/images/comp-off.svg";
import TakenLeaves from "../../assets/images/takenLeaves.svg";
import TotalLeaves from "../../assets/images/totalLeaves.svg";

import DoughnutChart from "../Charts/Doughnut";
import DashboardService from "../../services/dashboard.service";

const EmpDashboardStats = ({ rowData }) => {
  const user = AuthService.getCurrentUser();

  const location = useLocation();

  // console.log("rowData", rowData);

  const [monthLeaves, setmonthLeaves] = useState({
    lop: "1.0",
    paidleave: "2.5",
    goodwill: "0.0",
    totalTakenLeaves: "3.5",
    monthlyAllocatedleaves: "4.5",
    monthBalanceLeaves: "2.0",
  });

  const [quarterLeaves, setQuarterLeaves] = useState({
    lop: "0.0",
    paidleave: "0.0",
    goodwill: "0.0",
    totalTakenLeaves: "0.0",
    quarterlyAllocatedleaves: "18.0",
    queterBalance: "18.0",
    totalPaidTakenLeaves: "0.0",
  });

  const [yearLeaves, setYearLeaves] = useState({
    lop: "0.0",
    paidleave: "0.0",
    goodwill: "0.0",
    totalTakenLeaves: "0.0",
    yearlyAllocatedleaves: "18.0",
    yealrlyBalanceLeaves: "18.0",
    totalPaidTakenLeaves: "0.0",
  });

  const [selectedQuarter, setSelectedQuarter] = useState(null);

  const [date, setDate] = useState(new Date());
  const [quarterYear, setQuarterYear] = useState(new Date());
  const [year, setYear] = useState(new Date());

  const lists = [
    { name: "Q1", code: "1" },
    { name: "Q2", code: "2" },
    { name: "Q3", code: "3" },
    { name: "Q4", code: "4" },
  ];

  const fetchEmpQuarterLeaveOverview = (year, quarter) => {
    const payload = {
      empId:
        user.role === "1" || user.role === "4"
          ? rowData && rowData.empId
          : user.role === "2" && location.pathname === "/empLeaveHistory"
          ? rowData && rowData.empid
          : user && user.empid,
      year: year ? moment(new Date(year)).format("YYYY") : "",
      quarter: quarter ? quarter.code : "",
    };

    // console.log(payload);

    DashboardService.getEmpQuarterLeaveOverview(payload)
      .then((resp) => {
        if (resp.data) {
          setQuarterLeaves(resp.data);
        }
      })
      .catch((e) => console.log(e));
  };

  const fetchEmpYearLeaveOverview = (year) => {
    const payload = {
      empId:
        user.role === "1" || user.role === "4"
          ? rowData && rowData.empId
          : user.role === "2" && location.pathname === "/empLeaveHistory"
          ? rowData && rowData.empid
          : user && user.empid,
      year: year ? moment(new Date(year)).format("YYYY") : "",
    };

    // console.log(payload);

    DashboardService.getEmpLeaveOverview(payload)
      .then((resp) => {
        if (resp.data) {
          setYearLeaves(resp.data);
        }
      })
      .catch((e) => console.log(e));
  };

  const fetchEmpMonthLeaveOverview = (date) => {
    const payload = {
      empId:
        user.role === "1" || user.role === "4"
          ? rowData && rowData.empId
          : user.role === "2" && location.pathname === "/empLeaveHistory"
          ? rowData && rowData.empid
          : user && user.empid,
      year: date ? moment(new Date(date)).format("YYYY") : "",
      month: date ? moment(new Date(date)).format("M") : "",
    };

    // console.log(payload);

    DashboardService.getEmpMonthLeaveOverview(payload)
      .then((resp) => {
        if (resp.data) {
          setmonthLeaves(resp.data);
        }
      })
      .catch((e) => console.log(e));
  };

  const handleDateChange = (e) => {
    setDate(e.value);
    fetchEmpMonthLeaveOverview(e.value)
  };

  const handleQuarterYear = (e) => {
    setQuarterYear(e.value);
    fetchEmpQuarterLeaveOverview(e.value, selectedQuarter);
  };

  const handleYearChange = (e) => {
    setYear(e.value);
    fetchEmpYearLeaveOverview(e.value)
  };

  const getQuarterFromCurrentDate = () => {
    const month = new Date().getMonth() + 1; // getMonth() returns 0–11
    const quarter = Math.ceil(month / 3);
    const selectedQuarter = lists.filter(
      (item) => item.code === quarter.toString()
    );
    setSelectedQuarter(selectedQuarter[0]);
    fetchEmpQuarterLeaveOverview();
  };

  useEffect(() => {
    getQuarterFromCurrentDate();
    fetchEmpYearLeaveOverview();
  }, []);

  useEffect(() => {
    fetchEmpMonthLeaveOverview();
  }, []);

  return (
    <>
      <div className="emp-stats">
        <div className="monthly mb-3">
          <div className="d-flex mb-3">
            <div className="heading arrow-flex">
              <span>
                {user.role === "2" ||
                user.role === "3" ||
                location.pathname === "/empLeaveHistory"
                  ? "Monthly Used Leaves"
                  : user.role === "4"
                  ? "Leaves Status"
                  : ""}
              </span>
              {user.role === "2" || user.role === "3" ? (
                <Link to={"/leaveHistory"}>
                  <span className="arrow">
                    <img src={ArrowIcon} alt="" />
                  </span>
                </Link>
              ) : (
                <></>
              )}
            </div>
            <div className="filter ">
              <div className="new-calendar-type flex justify-content-center month-year">
                <MonthCalendar
                  value={date}
                  onChange={handleDateChange}
                  view="month"
                  dateFormat="M, yy"
                  style={{ height: "100%" }}
                  showIcon
                />
              </div>
            </div>
          </div>
          <div className="list">
            {user.role === "2" ||
            user.role === "3" ||
            (location.pathname === "/empLeaveHistory" &&
              rowData &&
              rowData.isprobationsts === "0") ? (
              <>
               <div className="item">
                  <div className="flex">
                    <div className="text">
                      <span>Total Leaves</span>
                      <span className="count">{monthLeaves.monthlyAllocatedleaves}</span>
                    </div>
                    <div className="icon">
                      <img src={TakenLeaves} alt="" />
                    </div>
                  </div>
                </div>
                <div className="item">
                  <div className="flex">
                    <div className="text">
                      <span>Earned Leaves</span>
                      <span className="count">{monthLeaves.paidleave}</span>
                    </div>
                    <div className="icon">
                      <img src={EarnedLeave} alt="" />
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}

            <div className="item">
              <div className="flex">
                <div className="text">
                  <span>Loss Of Pay</span>
                  <span className="count">{monthLeaves.lop}</span>
                </div>
                <div className="icon">
                  <img src={LOP} alt="" />
                </div>
              </div>
            </div>
            <div className="item compoff">
              <div
                className="flex"
              >
                <div className="text">
                  <span>Goodwill</span>
                  <span className="count">{monthLeaves.goodwill}</span>
                </div>
                <div className="icon">
                  <img src={CompOff} alt="" />
                </div>
              </div>
            </div>
            {user.role === "2" ||
            user.role === "3" ||
            (location.pathname === "/empLeaveHistory" &&
              rowData &&
              rowData.isprobationsts === "0") ? (
              <div className="item">
                <div className="flex">
                  <div className="text">
                    <span>Balance Leaves</span>
                    <span className="count">
                      {monthLeaves.monthBalanceLeaves}
                    </span>
                  </div>
                  <div className="icon">
                    <img src={TotalLeaves} alt="" />
                  </div>
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>

        {user.role === "2" ||
        user.role === "3" ||
        location.pathname === "/empLeaveHistory" ? (
          <div className="row">
            <div className="col-xl-6 col-lg-12">
              <div className="quarterly mb-3">
                <div className="d-flex mb-3">
                  <div className="heading">
                    <span>Quarterly Taken Leaves</span>
                  </div>
                  <div className="filter">
                    <div className="quarter">
                      <Dropdown
                        value={selectedQuarter}
                        onChange={(e) => {
                          setSelectedQuarter(e.value);
                          fetchEmpQuarterLeaveOverview(quarterYear, e.value);
                        }}
                        options={lists}
                        optionLabel="name"
                        placeholder="Select Quarter"
                        className=""
                      />
                    </div>

                    <div className="new-calendar-type flex justify-content-center year">
                      <MonthCalendar
                        value={quarterYear}
                        onChange={handleQuarterYear}
                        view="year"
                        dateFormat="yy"
                        style={{ height: "100%" }}
                        showIcon
                      />
                    </div>
                  </div>
                </div>
                <div className="q-flex">
                  <div className="list">
                    {(location.pathname === "/empLeaveHistory" &&
                      rowData &&
                      rowData.isprobationsts === "0") ||
                    (rowData && rowData.probation === "0") ||
                    (location.pathname === "/dashboard" &&
                      user &&
                      user.isOnProbation === "0") ? (
                      <>
                        <div className="total">
                          <DoughnutChart
                            type="Total"
                            newData={quarterLeaves.quarterlyAllocatedleaves}
                            maxValue={quarterLeaves.quarterlyAllocatedleaves}
                          />
                          <div className="text">
                            <span className="circle all"></span>
                            <span>Total</span>
                          </div>
                        </div>
                        <div className="total">
                          <DoughnutChart
                            type="Used"
                            newData={quarterLeaves.paidleave}
                            maxValue={quarterLeaves.quarterlyAllocatedleaves}
                          />
                          <div className="text">
                            <span className="circle used"></span>
                            <span>Paid</span>
                          </div>
                        </div>
                        <div className="total">
                          <DoughnutChart
                            type="Balance"
                            newData={quarterLeaves.queterBalance}
                            maxValue={quarterLeaves.quarterlyAllocatedleaves}
                          />
                          <div className="text">
                            <span className="circle balance"></span>
                            <span>Balance</span>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="total">
                          <DoughnutChart
                            type="Total"
                            newData={quarterLeaves.totalTakenLeaves}
                            maxValue={quarterLeaves.quarterlyAllocatedleaves}
                          />
                          <div className="text">
                            <span className="circle all"></span>
                            <span>Leaves Taken</span>
                          </div>
                        </div>
                      </>
                    )}

                    <div className="total">
                      <DoughnutChart
                        type="LOP"
                        newData={quarterLeaves.lop}
                        maxValue={quarterLeaves.quarterlyAllocatedleaves}
                      />
                      <div className="text">
                        <span className="circle lop"></span>
                        <span>LOP</span>
                      </div>
                    </div>
                    <div className="total">
                      <DoughnutChart
                        type="compoff"
                        newData={quarterLeaves.goodwill}
                        maxValue={quarterLeaves.quarterlyAllocatedleaves}
                      />
                      <div className="text">
                        <span className="circle lop"></span>
                        <span>Goodwill</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-12">
              <div className="quarterly mb-3">
                <div className="d-flex mb-3">
                  <div className="heading">
                    <span>Yearly Used Leaves</span>
                  </div>
                  <div className="filter">
                    <div className="new-calendar-type flex justify-content-center year">
                      <MonthCalendar
                        value={year}
                        onChange={handleYearChange}
                        view="year"
                        dateFormat="yy"
                        style={{ height: "100%" }}
                        showIcon
                      />
                    </div>
                  </div>
                </div>
                <div className="q-flex">
                  <div className="list">
                    {(location.pathname === "/empLeaveHistory" &&
                      rowData.isprobationsts === "0") ||
                    (location.pathname === "/dashboard" &&
                      user &&
                      user.isOnProbation === "0") ? (
                      <>
                        <div className="total">
                          <DoughnutChart
                            type="Total"
                            newData={yearLeaves.yearlyAllocatedleaves}
                            maxValue={yearLeaves.yearlyAllocatedleaves}
                          />
                          <div className="text">
                            <span className="circle all"></span>
                            <span>Total</span>
                          </div>
                        </div>
                        <div className="total">
                          <DoughnutChart
                            type="Used"
                            newData={yearLeaves.paidleave}
                            maxValue={yearLeaves.yearlyAllocatedleaves}
                          />
                          <div className="text">
                            <span className="circle used"></span>
                            <span>Paid</span>
                          </div>
                        </div>
                        <div className="total">
                          <DoughnutChart
                            type="Balance"
                            newData={yearLeaves.yealrlyBalanceLeaves}
                            maxValue={yearLeaves.yearlyAllocatedleaves}
                          />
                          <div className="text">
                            <span className="circle balance"></span>
                            <span>Balance</span>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="total">
                          <DoughnutChart
                            type="Total"
                            newData={yearLeaves.totalTakenLeaves}
                            maxValue={yearLeaves.yearlyAllocatedleaves}
                          />
                          <div className="text">
                            <span className="circle all"></span>
                            <span>Leaves Taken</span>
                          </div>
                        </div>
                      </>
                    )}

                    <div className="total">
                      <DoughnutChart
                        type="LOP"
                        newData={yearLeaves.lop}
                        maxValue={yearLeaves.yearlyAllocatedleaves}
                      />
                      <div className="text">
                        <span className="circle lop"></span>
                        <span>LOP</span>
                      </div>
                    </div>
                    <div className="total">
                      <DoughnutChart
                        type="compoff"
                        newData={yearLeaves.goodwill}
                        maxValue={yearLeaves.yearlyAllocatedleaves}
                      />
                      <div className="text">
                        <span className="circle lop"></span>
                        <span>Goodwill</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default EmpDashboardStats;
